export default __webpack_public_path__ + "static/media/gallery_00.62dd7e7d.jpg";